import type { RouterConfig } from '@nuxt/schema'

export default {
    // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
    stringifyQuery (query) {
        const {stringifyQuery} = useCrudConverters();
        return stringifyQuery(query);
    },
    parseQuery (query) {
        const {parseQuery} = useCrudConverters();
        return parseQuery(query);
    }
} satisfies RouterConfig
